import TruckAndDriverBaseController from "./truck_and_driver_base_controller"

export default class extends TruckAndDriverBaseController {
  static outlets = [
    "truck-gate-in--form-manager",
    "truck-gate-in--truck-drivers",
    "truck-gate-in--validations",
  ]
  static targets = [
    'errors',
    'truck',
  ]

  async handleTruckChange() {
    const truckId = this.truckTarget.value
    if (truckId && truckId.trim() !== '') {
      this.clearPresenceError()
    }
    await this.validateSelection(truckId)
    this.updateSubmissionLock()

    const info = await this.#fetchCompanyAndDriverInfo(truckId)

    // Sticky drivers
    if (info?.company_sticky_drivers && info.driver_id && this.hasTruckGateInTruckDriversOutlet) {
      this.truckGateInTruckDriversOutlet.setStickyDriver(
        info.driver_id,
        info.driver_full_name || info.driver_name,
        info.driver_select_text
      )
    }

    const whitelist = info?.company_whitelist_of_consignee_ids || []
    const companyName = info?.trucking_company_name || null
    if (!this.hasTruckGateInValidationsOutlet) return
    this.truckGateInValidationsOutlets.forEach((panel) =>
      panel.setConsigneeWhitelist(whitelist, companyName),
    )
  }

  buildValidateUrl(truckId) {
    return `/validations/truck_visit_eligibility/validate_truck/${truckId}`
  }

  validatePresence(event) {
    if (!this.requiredValue) return
    const truckId = this.truckTarget.value

    if (truckId && truckId.trim() !== '') {
      this.clearPresenceError()
    } else {
      event.preventDefault()
      this.setPresenceError('You must select a truck.')
    }
    this.updateSubmissionLock()
  }

  /**
   * Fetches the full company + driver JSON payload for the given truck.
   * Returns the parsed object or `null` on error.
   */
  async #fetchCompanyAndDriverInfo(truckId) {
    if (!truckId) return null
    try {
      const resp = await fetch(
        `/trucks/${truckId}/visit/company_and_driver_info.json`,
        { headers: this.requestHeaders },
      )
      return await resp.json()
    } catch (err) {
      console.error("Company/Driver info fetch error:", err)
      return null
    }
  }

  updateSubmissionLock() {
    const truckId = this.truckTarget.value
    if (this.requiredValue && (!truckId || truckId.trim() === "")) {
      this.lockSubmission("truckRequired")
    } else {
      this.unlockSubmission("truckRequired")
    }
  }
}
